import { render, staticRenderFns } from "./CartPedidoPage.vue?vue&type=template&id=60a5ca0a&scoped=true&"
import script from "./CartPedidoPage.vue?vue&type=script&lang=js&"
export * from "./CartPedidoPage.vue?vue&type=script&lang=js&"
import style0 from "./CartPedidoPage.vue?vue&type=style&index=0&id=60a5ca0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5ca0a",
  null
  
)

export default component.exports